<app-header></app-header>
<div class="form-wrapper">
	<div class="container">
		<div class="logo-container">
			<div class="logo-wrapper cursor-pointer" (click)="utilityService.navigate('/')" >
				<img alt="tenderpilot-logo" src="../../../assets/logo/tp-logo-voll-quer.svg" width="390">
			</div>
		</div>
		<br>
		<div class="form" *ngIf="validCode">
			<div>
				<app-password-field (password)="password = $event" (passwordValid)="passwordValid = $event"></app-password-field>
				<button nz-button class="login-form-button login-form-margin btn-color-default" [nzType]="'primary'"
					[disabled]="!passwordValid" nzBlock
					(click)="submitResetPasswordForm()">
					{{ "global.reset_password.label.set_new_password" | translate }}</button>

			</div>
		</div>
		<div class="form" *ngIf="invalidCode">
			<div>
				<div class="login-form">
					<div class="mb-2">
						{{ "global.reset_password.label.expired_code_message" | translate }}
					</div>
					<button nz-button class="mt-2 btn-color-default" nzSize="large" (click)="resetPasswordAgain()"
						[nzType]="'primary'" nzBlock>
						{{ "global.reset_password.label.reset_password_again" | translate }}</button>
				</div>
			</div>
		</div>
	</div>
</div>
<app-footer></app-footer>
